// Filter panel fields and the labels of active filter chips.
import {
  COMPARE_OPTIONS,
  RATING_OPTIONS,
  SENTIMENT_BY_KEY,
  SENTIMENTS,
  URGENCY_LABELS,
} from "./constants";

// All filters live in the "Filtry" panel; the bar above the tabs only holds the period presets.
const FilterFields = ({ filters, options, onChange }) => (
  <div className="gr-filter-fields gr-filter-fields-sheet">
    <label className="gr-field">
      <span>Porównanie</span>
      <select
        value={filters.compare}
        onChange={(e) => onChange({ compare: e.target.value })}
        disabled={filters.period === "all"}
      >
        {COMPARE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
    <label className="gr-field">
      <span>Dział</span>
      <select
        value={filters.department}
        onChange={(e) => onChange({ department: e.target.value })}
      >
        <option value="">Wszystkie działy</option>
        {(options?.departments || []).map((d) => (
          <option key={d.key} value={d.key}>
            {d.label} ({d.count})
          </option>
        ))}
      </select>
    </label>
    <label className="gr-field">
      <span>Sentyment</span>
      <select
        value={filters.sentiment}
        onChange={(e) => onChange({ sentiment: e.target.value })}
      >
        <option value="">Każdy sentyment</option>
        {SENTIMENTS.map((s) => (
          <option key={s.key} value={s.key}>
            {s.label}
          </option>
        ))}
      </select>
    </label>
    <label className="gr-field">
      <span>Ocena</span>
      <select
        value={filters.rating}
        onChange={(e) => onChange({ rating: e.target.value })}
      >
        {RATING_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
    <label className="gr-field">
      <span>Pracownik</span>
      <select
        value={filters.employee}
        onChange={(e) => onChange({ employee: e.target.value })}
      >
        <option value="">Wszyscy</option>
        {(options?.employees || []).map((e) => (
          <option key={e.key} value={e.key}>
            {e.label} ({e.count})
          </option>
        ))}
      </select>
    </label>
    <label className="gr-field">
      <span>Produkt</span>
      <select
        value={filters.product}
        onChange={(e) => onChange({ product: e.target.value })}
      >
        <option value="">Wszystkie</option>
        {(options?.products || []).map((p) => (
          <option key={p.key} value={p.key}>
            {p.label} ({p.count})
          </option>
        ))}
      </select>
    </label>
    <label className="gr-field">
      <span>Pilność</span>
      <select
        value={filters.urgency}
        onChange={(e) => onChange({ urgency: e.target.value })}
      >
        <option value="">Każda</option>
        {Object.entries(URGENCY_LABELS).map(([k, l]) => (
          <option key={k} value={k}>
            {l}
          </option>
        ))}
      </select>
    </label>
  </div>
);

export const describeChip = (key, value, options) => {
  const find = (list) => list?.find((i) => i.key === value)?.label || value;
  switch (key) {
    case "employee":
      return `Pracownik: ${value}`;
    case "topic":
      return `Temat: ${find(options?.topics)}`;
    case "theme":
      return `${{ praise: "Pochwały", complaint: "Skargi" }[options?.themeSide] || "Kategoria"}: ${find(options?.themes)}`;
    case "strength":
      return `Mocna strona: ${value}`;
    case "weakness":
      return `Słaba strona: ${value}`;
    case "product":
      return `Produkt: ${find(options?.products)}`;
    case "urgency":
      return `Pilność: ${URGENCY_LABELS[value] || value}`;
    case "hasText":
      return value === "true" ? "Tylko z treścią" : "Tylko bez treści";
    case "hasReply":
      return value === "true" ? "Z odpowiedzią firmy" : "Bez odpowiedzi firmy";
    case "search":
      return `Szukaj: „${value}”`;
    case "department":
      return `Dział: ${find(options?.departments)}`;
    case "sentiment":
      return `Sentyment: ${SENTIMENT_BY_KEY[value]?.label || value}`;
    case "rating":
      return `Ocena: ${RATING_OPTIONS.find((o) => o.value === value)?.label || value}`;
    default:
      return value;
  }
};

export default FilterFields;
